import { render, staticRenderFns } from "./XmExportHistory.vue?vue&type=template&id=523b11a8&scoped=true"
import script from "./XmExportHistory.vue?vue&type=script&lang=js"
export * from "./XmExportHistory.vue?vue&type=script&lang=js"
import style0 from "./XmExportHistory.vue?vue&type=style&index=0&id=523b11a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b11a8",
  null
  
)

export default component.exports